import { type OnboardingValues } from '@/features/onboarding/constants';

export function getDevOnboardingFixture(): OnboardingValues {
  return {
    email: 'alex.morgan@besthuman.test',
    alternateEmail: 'alex.personal@besthuman.test',
    firstName: 'Alex',
    lastName: 'Morgan',
    city: 'Vancouver',
    country: 'Canada',
    timezone: 'America/Vancouver',
    age: '35-44',
    company: 'Northwind Labs',
    title: 'Director of Operations',
    experience: '11-15',
    linkedin: 'https://www.linkedin.com/in/alex-morgan-preview',
    noLinkedin: false,
    careerGoals: 'Build a stronger leadership voice and create more space for strategic work.',
    leadershipExperience: '4-5 years',
    learningStyle: 'Small-group discussion, practical examples, and time to reflect afterward.',
    accessibility: '',
    confidentialityConfirmed: true
  };
}
